import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const SolutionsGrid = () => {
  const navigate = useNavigate();

  const solutions = [
    {
      icon: '🩺',
      title: 'Anesthesiology',
      description: 'Specialized billing for complex anesthesia coding and time-based requirements.',
      path: '/anesthesiology',
      color: 'bg-teal-50 border-teal-200 hover:border-teal-400'
    },
    {
      icon: '🔬',
      title: 'Dermatology',
      description: 'Expert billing for medical and cosmetic dermatology procedures.',
      path: '/dermatology',
      color: 'bg-navy-50 border-navy-200 hover:border-navy-400'
    },
    {
      icon: '🏥',
      title: 'Hospitalist',
      description: 'Comprehensive billing solutions for hospitalist programs and inpatient care.',
      path: '/hospitalist',
      color: 'bg-teal-50 border-teal-200 hover:border-teal-400'
    },
    {
      icon: '🧠',
      title: 'Mental Health',
      description: 'Specialized billing for psychiatry, psychology, and behavioral health.',
      path: '/mental-health',
      color: 'bg-navy-50 border-navy-200 hover:border-navy-400'
    },
    {
      icon: '👶',
      title: 'OB-GYN',
      description: 'Complete billing for obstetrics and gynecology including global packages.',
      path: '/obgyn',
      color: 'bg-teal-50 border-teal-200 hover:border-teal-400'
    },
    {
      icon: '💊',
      title: 'Oncology',
      description: 'Expert billing for chemotherapy, infusions, and cancer treatment.',
      path: '/oncology',
      color: 'bg-navy-50 border-navy-200 hover:border-navy-400'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block bg-teal-500 text-white px-5 py-2 rounded-full text-sm font-semibold mb-4">
            Who We Serve
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Specialized Billing for Your Practice
          </h2>
          <p className="text-lg text-gray-600">
            We provide specialized medical billing services tailored to the unique needs of each specialty.
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {solutions.map((solution, index) => (
            <div
              key={index}
              onClick={() => navigate(solution.path)}
              className={`group cursor-pointer rounded-2xl p-6 border-2 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${solution.color}`}
            >
              <div className="flex items-start gap-4">
                <div className="text-4xl group-hover:scale-110 transition-transform duration-300">
                  {solution.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-600 transition-colors flex items-center gap-2">
                    {solution.title}
                    <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/who-we-serve')}
            className="inline-flex items-center gap-2 bg-navy-600 hover:bg-navy-700 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 group shadow-lg hover:shadow-xl"
          >
            View All Specialties
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};
